import { useEffect, useState } from 'react';

const REFRESH_INTERVAL_MS = 60 * 1000;

export function useTemperatureGraphData(traceUuid, goodId) {
    const [points, setPoints] = useState([]);
    const [status, setStatus] = useState('loading');
    const [lastUpdatedAt, setLastUpdatedAt] = useState(null);

    useEffect(() => {
        if (goodId === null) return;

        let cancelled = false;

        function fetchGraphData() {
            fetch(`/track-and-trace/${traceUuid}/temperatuur/${goodId}`, {
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
            })
                .then((response) => {
                    if (!response.ok) throw new Error(response.statusText);
                    return response.json();
                })
                .then((graphPoints) => {
                    if (cancelled) return;
                    setPoints(graphPoints);
                    setStatus(graphPoints.length > 0 ? 'ok' : 'empty');
                    setLastUpdatedAt(new Date());
                })
                .catch(() => {
                    if (cancelled) return;
                    setPoints([]);
                    setStatus('error');
                });
        }

        fetchGraphData();
        const interval = setInterval(fetchGraphData, REFRESH_INTERVAL_MS);

        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [traceUuid, goodId]);

    return { points, status, lastUpdatedAt };
}
